const AjaxUtils = {
    postData(url = '', data = {}, signal = null) {
        let headers = {};

        let newData = data;

        if (!(data instanceof FormData)) {
            newData = new URLSearchParams();

            // Append all data into newData
            Object.keys(data).forEach(key => {
                // If value is a FormData, append all entries of FormData into newData
                if (data[key] instanceof FormData) {
                    data[key].forEach((formValue, formKey) => {
                        newData.append(formKey, formValue);
                    });
                } else {
                    newData.append(key, data[key]);
                }
            });
            headers = { 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8' };
        }

        const args = {
            method: 'POST',
            headers,
            credentials: 'same-origin',
            body: newData,
        };

        if (signal) {
            args.signal = signal;
        }

        const response = fetch(url, args);
        
        if (data.return_json === false) {
            return response;
        }
        
        return response.then(r => r.json());
    },
    
    getData(url = '', data = {}, signal = null) {
        let headers = {};
    
        const urlParams = Object.keys(data).map(function(key) {
            return key + '=' + data[key];
        }).join('&');

        headers = { 'Content-Type': 'application/json' };

        const args = {
            method: 'GET',
            headers,
            credentials: 'same-origin',
        };

        if (signal) {
            args.signal = signal;
        }

        url += '?' + urlParams;
        
        const response = fetch(url, args);
        return response.then(r => r.json());
    },

};

export default AjaxUtils;
